import { withInstall, withInstallDirective } from '@jdesign-vue/utils'

import Popover from './src/popover.vue'
import PopoverDirective, { VPopover } from './src/directive'

export const JdPopoverDirective = withInstallDirective(
  PopoverDirective,
  VPopover
)

export const JdPopover = withInstall(Popover, {
  directive: JdPopoverDirective,
})
export default JdPopover

export * from './src/popover'
